import { uniqBy } from 'lodash-es'

import {
  CameraSettingsPayload,
  Deployment,
  EventEndpoint,
  InputSourceType
} from '@/types/deployment'

/**
 * Finds the event endpoints we need across all deployments (using the `service` field).
 * If the same service shows up more than once, we just keep the first one.
 *
 * Why:
 * Some setups mix Milestone and non-Milestone cameras. Non-Milestone deployments might not
 * include the Milestone endpoint, so we collect endpoints from everywhere to avoid missing it.
 */
export const getInitialEventEndpoints = (
  deployments: Deployment[]
): EventEndpoint[] => {
  const allEndpoints = deployments
    .filter(
      (d) => d.settings_payload?.input_source_type === InputSourceType.Cameras
    )
    .flatMap(
      (d) => (d.settings_payload as CameraSettingsPayload).event_endpoints
    )

  return uniqBy(allEndpoints, 'service')
}
